interface PaginationProps {
  page: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  const baseClass =
    'flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors cursor-pointer';

  return (
    <nav aria-label="分页导航" className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`${baseClass} border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? 'page' : undefined}
          className={`${baseClass} ${
            item === page
              ? 'border-primary-600 bg-primary-600 text-background-50'
              : 'border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, page + 1))}
        disabled={page === total}
        className={`${baseClass} border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}